import React from "react";
import { useHistory } from "react-router-dom";
import styles from "./ServiceNameForm.module.css";
import { FaAngleLeft, FaSpinner } from "react-icons/fa";
import { ServiceSignupContext } from "../../context/ServiceSignupContext";

const { useContext } = React;

const ServiceNameForm = ({ setName }) => {
  const history = useHistory();
  const { serviceName, loading, onFinish, innerHeight } = useContext(
    ServiceSignupContext
  );

  return (
    <div
      className={`${styles.mainContent} ${
        innerHeight <= 900 ? "transform scale-80" : ""
      } `}
    >
      <div className={styles.headerClip}>
        <svg
          width="289"
          height="142"
          viewBox="0 0 289 142"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M207.224 7.71052L201.173 23.9396L190.144 10.5846L207.224 7.71052Z"
            fill="#8BC334"
          />
          <path
            d="M239.945 111.372L233.801 106.094L241.444 103.413L239.945 111.372Z"
            fill="#8BC334"
          />
          <path
            d="M9.11947 63.1871L8.53448 71.2657L1.83067 66.7198L9.11947 63.1871Z"
            fill="#8BC334"
          />
          <path
            d="M85.4634 119.301L99.7331 129.118L84.0965 136.567L85.4634 119.301Z"
            fill="#8BC334"
          />
          <path
            d="M252.014 31.4376L249.432 42.3365L241.284 34.6503L252.014 31.4376Z"
            fill="#E7E7E7"
          />
          <path
            d="M42.3586 56.927L49.9167 56.4094L46.5859 63.2137L42.3586 56.927Z"
            fill="#E7E7E7"
          />
          <path
            d="M203.689 133.127L186.919 128.795L199.056 116.437L203.689 133.127Z"
            fill="#FBD539"
          />
          <path
            d="M90.2741 24.4662L84.4414 8.15734L101.482 11.2605L90.2741 24.4662Z"
            fill="#FBD539"
          />
          <path
            d="M227.288 67.1859L224.255 79.8976L214.763 70.9153L227.288 67.1859Z"
            fill="#F56666"
          />
          <path
            d="M66.0522 70.7536L76.7979 63.3162L77.8661 76.3409L66.0522 70.7536Z"
            fill="#F56666"
          />
          <path
            d="M204.379 96.5962L204.208 89.9364L210.061 93.1187L204.379 96.5962Z"
            fill="#7D68FC"
          />
          <path
            d="M95.5659 49.3877L90.9578 44.5764L97.4286 42.9914L95.5659 49.3877Z"
            fill="#7D68FC"
          />
          <path
            d="M271.845 98.7767L262.28 98.2835L267.49 90.2469L271.845 98.7767Z"
            fill="#388CEF"
          />
          <path
            d="M30.97 28.6245L33.1106 37.9596L23.9559 35.1458L30.97 28.6245Z"
            fill="#388CEF"
          />
          <path
            d="M288.464 65.4823L281.796 69.4599L281.686 61.6964L288.464 65.4823Z"
            fill="#FCD53A"
          />
          <path
            d="M30.1232 102.527L34.8916 96.3989L37.8141 103.592L30.1232 102.527Z"
            fill="#FCD53A"
          />
          <g>
            <path
              d="M168.2 42.33C167.184 42.5315 166.521 43.5402 166.724 44.5221C166.724 44.5469 166.724 44.5469 166.751 44.5739C166.928 45.4301 167.718 46.0594 168.607 46.0594C168.734 46.0594 168.888 46.0346 169.014 46.0077C170.033 45.7814 170.694 44.7753 170.465 43.7666C170.234 42.7578 169.194 42.1037 168.2 42.33Z"
              fill="#388CEF"
            />
            <path
              d="M128.597 90.4269C128.825 90.4269 129.054 90.4 129.283 90.2993C130.249 89.9232 130.758 88.8379 130.376 87.8567C130.376 87.8567 130.376 87.8567 130.351 87.8319C129.995 86.9238 128.851 86.4201 127.909 86.7741C127.426 86.9486 127.044 87.3033 126.84 87.7801C126.637 88.2355 126.637 88.7371 126.815 89.1918C126.815 89.2167 126.815 89.2167 126.815 89.2167C127.094 89.9474 127.808 90.4269 128.597 90.4269Z"
              fill="#388CEF"
            />
            <path
              d="M133.227 48.3712C133.227 55.857 139.375 61.9456 146.933 61.9456C154.492 61.9456 160.64 55.857 160.64 48.3712C160.64 40.8854 154.492 34.7969 146.933 34.7969C139.375 34.7969 133.227 40.8854 133.227 48.3712ZM156.824 48.3712C156.824 53.7732 152.388 58.1672 146.933 58.1672C141.477 58.1672 137.041 53.7739 137.041 48.3712C137.041 42.9685 141.477 38.5753 146.933 38.5753C152.388 38.5753 156.824 42.9692 156.824 48.3712Z"
              fill="#388CEF"
            />
            <path
              d="M146.934 101.945C140.756 101.945 135.729 106.924 135.729 113.045C135.729 118.356 144.206 138.557 145.175 140.843C145.47 141.544 146.164 142.001 146.933 142.001C147.701 142.001 148.397 141.544 148.692 140.843C149.66 138.557 158.141 118.356 158.141 113.045C158.142 106.924 153.114 101.945 146.934 101.945ZM146.934 135.128C143.556 126.789 139.545 115.943 139.545 113.045C139.545 109.007 142.861 105.724 146.934 105.724C151.011 105.724 154.327 109.008 154.327 113.045C154.327 115.943 150.312 126.789 146.934 135.128Z"
              fill="#388CEF"
            />
            <path
              d="M180.672 67.0986C180.371 65.4626 179.385 64.0971 178.101 63.5368C176.256 62.7205 174.308 62.0457 172.325 61.4613C172.327 61.2653 172.346 61.0714 172.346 60.8755C172.346 56.8459 172.043 52.7894 171.431 48.8336C171.252 47.8007 170.286 47.0969 169.243 47.2466C168.2 47.3991 167.489 48.381 167.641 49.4139C168.226 53.1923 168.53 57.0474 168.53 60.8748C168.53 73.8219 165.173 86.5179 158.839 97.6028C151.718 93.0419 142.127 93.0419 135.03 97.6028C134.038 95.915 133.122 94.1514 132.31 92.3878C131.878 91.4556 130.68 91.0271 129.766 91.4556C129.54 91.5584 129.355 91.7129 129.19 91.8861C129.048 91.9193 128.935 91.9876 128.869 92.1028C127.13 95.1188 125.769 98.3411 124.81 101.724C124.703 101.636 124.586 101.515 124.467 101.35C117.568 91.6736 114.828 79.4351 116.954 67.7672C117.037 67.3118 117.255 67.0317 117.322 66.9847C118.727 66.3651 120.198 65.8421 121.693 65.3639C122.058 71.8272 123.169 78.191 125.112 84.352C125.341 85.1317 126.104 85.661 126.918 85.661C127.122 85.661 127.298 85.6361 127.477 85.5844C127.986 85.4346 128.366 85.1069 128.623 84.6543C128.851 84.1989 128.901 83.6951 128.749 83.2177C126.486 76.0127 125.342 68.48 125.342 60.8734C125.342 49.3049 127.962 38.169 132.882 28.1578H160.947C162.788 31.9003 164.329 35.7974 165.505 39.8132C165.811 40.7703 166.879 41.3754 167.895 41.1001C168.66 40.871 169.244 40.141 169.244 39.3116C169.244 39.1343 169.244 38.9576 169.194 38.8072C169.194 38.7824 169.194 38.7824 169.194 38.7555C167.851 34.2139 166.083 29.8096 163.942 25.6034C163.908 25.5157 163.857 25.4433 163.811 25.3633C160.376 18.6744 155.99 12.4948 150.778 7.11828L148.31 4.54803C147.597 3.81732 146.274 3.81732 145.563 4.54803L143.094 7.11897C129.181 21.4779 121.525 40.5453 121.525 60.8748C121.525 61.0708 121.545 61.264 121.546 61.4599C119.564 62.045 117.618 62.7171 115.774 63.532C114.48 64.0978 113.494 65.4654 113.198 67.1013C110.893 79.7553 113.864 93.0343 121.356 103.534C122.344 104.912 123.795 105.723 125.193 105.723C125.414 105.723 125.633 105.703 125.847 105.662C127.099 105.423 128.03 104.53 128.329 103.313C128.879 101.242 129.62 99.2305 130.505 97.2854C131.229 98.6502 131.989 100.004 132.793 101.33C133.073 101.81 133.555 102.137 134.089 102.213C134.218 102.238 134.32 102.238 134.422 102.238C134.854 102.238 135.287 102.113 135.617 101.835C138.821 99.3154 142.841 97.9057 146.937 97.9057C151.03 97.9057 155.05 99.3154 158.254 101.835C158.689 102.162 159.297 102.314 159.782 102.213C160.316 102.137 160.773 101.81 161.079 101.33C161.888 100.004 162.637 98.6461 163.362 97.2764C164.247 99.2201 164.989 101.225 165.535 103.276C165.841 104.53 166.772 105.423 168.024 105.662C168.238 105.704 168.456 105.723 168.677 105.723C170.076 105.723 171.526 104.911 172.518 103.529C180.006 93.0343 182.977 79.7552 180.672 67.0986ZM145.841 9.71406L146.936 8.60454L148.029 9.71406C152.269 14.1094 155.929 19.0573 158.946 24.3807H134.871C137.87 19.0925 141.534 14.1604 145.841 9.71406ZM169.405 101.344C169.286 101.511 169.166 101.632 169.059 101.723C168.197 98.6716 166.978 95.7363 165.46 92.9619C169.361 84.3113 171.649 74.9618 172.194 65.3694C173.681 65.8449 175.143 66.3651 176.529 66.9758C176.616 67.0323 176.832 67.3125 176.916 67.7706C179.043 79.4351 176.302 91.6736 169.405 101.344Z"
              fill="#388CEF"
            />
          </g>
        </svg>
      </div>

      <div className={styles.welcomeText}>
        Let&apos;s now add your service name.
      </div>
      <div className={styles.subText}>
        So we can personalise your Holistic QIP dashboard.
      </div>
      <input
        readOnly={loading}
        className={styles.serviceNameInput}
        placeholder={`Type in your service name`}
        value={serviceName}
        onChange={(e) => {
          setName(e.target.value);
        }}
      />
      <button
        onClick={() => {
          if (serviceName) {
            onFinish();
          }
        }}
        className={`${styles.nextButton} flex justify-center items-center`}
      >
        {!loading ? (
          <span className={` `}>
            You&apos;re&nbsp;done.&nbsp;Let&apos;s&nbsp;go!
          </span>
        ) : (
          <span className={`flex justify-center items-center`}>
            <FaSpinner className={`animate-spin`} />{" "}
            <span className={`ml-2`}>Redirecting...</span>{" "}
          </span>
        )}
      </button>
      <div
        onClick={() => {
          if (!loading) {
            history.goBack();
          }
        }}
        className={`${styles.backStep} flex justify-center items-center cursor-pointer`}
      >
        <FaAngleLeft className={styles.backArrow} />{" "}
        <span className={styles.backText}>Back a step</span>
      </div>
    </div>
  );
};

export default ServiceNameForm;
